<template>
    <div class="content-container">
        <div class="content h-auto">
            <!-- Loading state -->
            <loading-state v-if="loading" fullscreen></loading-state>
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>In Store Pre-Booking Created</h1>
                        </div>
                    </div>

                    <!-- Booking Details -->
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>To complete the booking either...</h4>
                            </div>
                            <div class="card-body pb-2">
                                <dl>
                                    <dt>Scan the QR code</dt>
                                    <dd>
                                        <qrcode-vue :value="qrCodeDataString" :size="100" level="H"></qrcode-vue>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Or enter the following code when booking</dt>
                                    <dd>
                                        <input class="form-input text-input mt-1" type="text" disabled :value="partnerBookingShortCode">
                                    </dd>
                                </dl>
                                <hr>
                                <dl>
                                    <dt>Pending Repair date</dt>
                                    <dd>{{ booking.full_date }}</dd>
                                </dl>
                                <dl>
                                    <dt>Devices</dt>
                                    <dd v-for="device in devices" :key="device.key">
                                        {{ device.device.title }}
                                    </dd>
                                </dl>
                                <hr>
                                <dl>
                                    <dt></dt>
                                    <dd><button class="btn btn-outline-primary btn-rounded btn-md" v-on:click="startNewBooking">Start New Booking</button></dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <!-- Important Information -->
                    <div class="col-12" v-if="false">
                        <div class="card">
                            <div class="card-header">
                                <h4>Important - before the repair</h4>
                            </div>
                            <div class="card-body pb-2">
                                <p>
                                    Check that you’ve booked the correct device (see above). If the model and/or colour is different to your device, contact Likewize Repair ASAP.
                                </p>
                                <p>
                                    Ensure there’s parking for the Likewize Repair workshop, not too far from where you live/work.
                                </p>
                                <p>
                                    On the morning of your repair, at 08.00, you’ll receive an email and a text confirming your Likewize Repair technician's estimated time of arrival (within one hour).
                                </p>
                                <p>
                                    Your technician will arrive and complete the repair in approximately 45 minutes.
                                </p>
                                <p>
                                    Your device will be returned, repaired and fully tested.
                                </p>
                                <p class="text-center">
                                    <button class="btn btn-success btn-lg" @click="startNewBooking">Start a new booking</button>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Contact -->
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>Contact Likewize Repair</h4>
                            </div>
                            <div class="card-body pb-2">
                                <p>
                                    Telephone: {{ carrierDetails.phone }}
                                </p>
                                <p>
                                    Email: <a :href="`mailto:`+carrierDetails.email">{{ carrierDetails.email }}</a>
                                </p>
                                <p>
                                    Web: <a :href="carrierDetails.web" target="_blank">{{ carrierDetails.formattedWeb }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import QrcodeVue from 'qrcode.vue'

export default {
    name: "InStoreBookingConfirmation",
    components: { QrcodeVue },

    data() {
        return {
            loading: true,
            partnerBookingUrl: '',
            partnerBookingShortCode: '',
        }
    },

    mounted() {
        this.confirmInStoreBooking();
    },

    computed: {
        ...mapGetters([
            "booking",
            "carrierDetails",
            "cartTotal",
            "devices",
            "inWarrantyStatus",
            "parseAddressToString",
            "reference",
            "repairLocationOption"
        ]),

        carrierName() {
            if (this.carrierDetails.name === "tesco-mobile") {
                return "Likewize Repair";
            }

            return this.carrierDetails.formattedName;
        },

        qrCodeDataString() {
            return this.partnerBookingUrl;
        }
    },

    methods: {
        ...mapActions([
            "clearBooking",
            "retrieveBooking"
        ]),

        confirmInStoreBooking() {
            this.$http.post('api/v4/partner/in-store-bookings/confirm', {
                wefix_booking_reference: this.reference
            }).then(response => {
                this.partnerBookingUrl = response.data.data.booking_url;
                this.partnerBookingShortCode = response.data.data.booking_short_code;
            }).catch(response => {
                console.error(response)
            }).then(() => {
                this.loading = false;
            })
        },

        startNewBooking() {
            this.clearBooking().then(() => {
                this.$router.push({name: 'booking'})
            });
        }
    },
}
</script>

<style scoped>

</style>